"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageError = exports.ProcessingError = exports.RequestError = exports.ApiError = exports.DocumentError = exports.CameraUnavailableError = exports.CameraPermissionError = exports.CameraError = exports.ValidationError = void 0;
const ErrorType_1 = require("./enums/ErrorType");
class ValidationError extends Error {
    constructor(message) {
        super(message);
        this.name = ErrorType_1.ErrorType.ValidationError;
    }
}
exports.ValidationError = ValidationError;
class CameraError extends Error {
    constructor(message) {
        super(message);
        this.name = ErrorType_1.ErrorType.CameraError;
    }
}
exports.CameraError = CameraError;
class CameraPermissionError extends Error {
    constructor(message) {
        super(message);
        this.name = ErrorType_1.ErrorType.CameraPermissionError;
    }
}
exports.CameraPermissionError = CameraPermissionError;
class CameraUnavailableError extends Error {
    constructor(message) {
        super(message);
        this.name = ErrorType_1.ErrorType.CameraUnavailableError;
    }
}
exports.CameraUnavailableError = CameraUnavailableError;
class DocumentError extends Error {
    constructor(message) {
        super(message);
        this.name = ErrorType_1.ErrorType.DocumentError;
    }
}
exports.DocumentError = DocumentError;
class ApiError extends Error {
    constructor(message) {
        super(message);
        this.name = ErrorType_1.ErrorType.ApiError;
    }
}
exports.ApiError = ApiError;
class RequestError extends Error {
    constructor(message) {
        super(message);
        this.name = ErrorType_1.ErrorType.RequestError;
    }
}
exports.RequestError = RequestError;
class ProcessingError extends Error {
    constructor(message) {
        super(message);
        this.name = ErrorType_1.ErrorType.ProcessingError;
    }
}
exports.ProcessingError = ProcessingError;
class ImageError extends Error {
    constructor(message) {
        super(message);
        this.name = ErrorType_1.ErrorType.ImageError;
    }
}
exports.ImageError = ImageError;
